import type { CardId } from '../../../../model/types';

export const SET_RICH_ACTIVE_CARD = 'state.actions.cards.rich-card.SET_RICH_ACTIVE_CARD' as const;

export type SetRichActiveCard = {
	type: typeof SET_RICH_ACTIVE_CARD;
	payload: {
		cardId: CardId | null;
	};
};

export const setRichActiveCard = (cardId: CardId | null): SetRichActiveCard => ({
	type: SET_RICH_ACTIVE_CARD,
	payload: {
		cardId,
	},
});

export const SET_CARD_ID_WITH_ABOVE_ICC_OPEN =
	'state.actions.cards.rich-card.SET_CARD_ID_WITH_ABOVE_ICC_OPEN' as const;

export type SetCardIdWithAboveICCOpen = {
	type: typeof SET_CARD_ID_WITH_ABOVE_ICC_OPEN;
	payload: {
		cardId: CardId | null;
	};
};

export const setCardIdWithAboveICCOpen = (cardId: CardId | null): SetCardIdWithAboveICCOpen => ({
	type: SET_CARD_ID_WITH_ABOVE_ICC_OPEN,
	payload: {
		cardId,
	},
});

export type Action = SetRichActiveCard | SetCardIdWithAboveICCOpen;
